module.exports = __webpack_public_path__ + "img/lg_ring_r_e_1_0@3x.54f6ce42.png";